import React, { useEffect, useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import useDisplayLinkPreview from "../../../utils/queries/message";

function MessageLinkPreview({ validContentLinks }) {
    const [currentLinkIndex, setCurrentLinkIndex] = useState(0);
    const [currentLinkPreview, setCurrentLinkPreview] = useState(null);
    const [displayImage, setDisplayImage] = useState(false);

    const { data: linkPreview } = useDisplayLinkPreview(currentLinkPreview, {
        options: {
            onError: () => {
                // Move to next link on error
                setCurrentLinkIndex((prevIndex) => prevIndex + 1);
            },
            enabled: !!currentLinkPreview,
            refetchOnWindowFocus: false,
            retry: 0,
        },
    });

    useEffect(() => {
        if (currentLinkIndex < validContentLinks?.length) {
            setCurrentLinkPreview(validContentLinks[currentLinkIndex]);
        }
    }, [currentLinkIndex, validContentLinks]);

    if (!validContentLinks || !linkPreview?.title) return null;

    const { image, title, description, domainName } = linkPreview;

    return (
        <div className="ek-chat__message--link-preview">
            {image && (
                <a href={currentLinkPreview} target="_blank" rel="noreferrer">
                    <img
                        src={image}
                        alt={title}
                        className={classNames(
                            "ek-chat__message--link-preview--img",
                            {
                                "ek-chat__message--link-preview--without-img":
                                    !displayImage,
                            }
                        )}
                        onLoad={() => setDisplayImage(true)}
                        onError={() => setDisplayImage(false)}
                    />
                </a>
            )}
            <div className="ek-chat__message--link-preview--content">
                <span className="ek-chat__message--link-preview--content--title">
                    <a
                        href={currentLinkPreview}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {title}
                    </a>
                </span>
                <span className="ek-chat__message--link-preview--content--description">
                    {description}
                </span>
                <span className="ek-chat__message--link-preview--content--domain-name">
                    {domainName}
                </span>
            </div>
        </div>
    );
}

MessageLinkPreview.propTypes = {
    validContentLinks: PropTypes.arrayOf(PropTypes.string),
};

MessageLinkPreview.defaultProps = {
    validContentLinks: [],
};

export default MessageLinkPreview;
